import { defineMessages } from 'react-intl';

export const scope = 'app.components.FormikDatePicker';

export default defineMessages({
  timeCaption: {
    id: `${scope}.timeCaption`,
    defaultMessage: 'Time',
  },
});
